import { render, staticRenderFns } from "./HMStudioBackButton.vue?vue&type=template&id=a0079c1e&scoped=true&"
import script from "./HMStudioBackButton.vue?vue&type=script&lang=js&"
export * from "./HMStudioBackButton.vue?vue&type=script&lang=js&"
import style0 from "./HMStudioBackButton.vue?vue&type=style&index=0&id=a0079c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0079c1e",
  null
  
)

export default component.exports